export default __webpack_public_path__ + "static/media/intellipro3.70636124.png";